import React from "react"

type Variant = "primary" | "secondary" | "ghost" | "danger" | "gold"
type Size = "md" | "lg" | "sm"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  block?: boolean
}

const VARIANTS: Record<Variant, string> = {
  primary:
    "bg-navy-800 text-white font-semibold hover:bg-navy-900 active:bg-navy-950 disabled:bg-slate-200 disabled:text-slate-400 shadow-sm",
  secondary:
    "border border-slate-300 bg-white text-navy-700 font-medium hover:bg-slate-50 hover:border-slate-400 disabled:opacity-50",
  ghost: "text-navy-600 font-medium hover:bg-slate-100 hover:text-navy-900 disabled:opacity-50",
  danger: "bg-red-600 text-white font-semibold hover:bg-red-700 active:bg-red-800 disabled:opacity-50",
  gold: "bg-gold-400 text-navy-950 font-semibold hover:bg-gold-300 active:bg-gold-500 shadow-sm disabled:bg-slate-200 disabled:text-slate-400",
}

const SIZES: Record<Size, string> = {
  sm: "px-3 py-1.5 text-sm rounded-lg",
  md: "px-4 py-2.5 text-sm rounded-xl",
  lg: "px-6 py-3.5 text-base rounded-xl",
}

export function Button({ variant = "primary", size = "md", block = false, className = "", ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center gap-2 transition-colors duration-150 disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${block ? "w-full" : ""} ${className}`}
      {...rest}
    />
  )
}
